declare module 'string-extensions' {
    interface String {
        toCamelCase(): string;
        capitalizeFirst(): string;
    }
}

interface String {
    toCamelCase(): string;
    capitalizeFirst(): string;
}

String.prototype.toCamelCase = function(): string {
    return this
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '')
        .replace(/[-_]/g, '');
};

String.prototype.capitalizeFirst = function(): string {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
